import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.birdChart`;
export const CHART_SCOPE = `${SCOPE}.chart`;
export const ZOOM_CHART_REQUEST_SCOPE = `${SCOPE}.zoomChartRequest`;
export const BRUSH_CHART_REQUEST_SCOPE = `${SCOPE}.brushChartRequest`;
export const BRUSH_COMPARE_CHART_REQUEST_SCOPE = `${SCOPE}.brushCompareChartRequest`;
export const SECONDARY_LINE_CHART_REQUEST_SCOPE = `${SCOPE}.secondaryLineChartRequest`;
export const SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE = `${SCOPE}.secondaryCompareLineChartRequest`;

export const INIT = `${SCOPE}/INIT`;

export const INIT_CHART = `${CHART_SCOPE}/INIT_CHART`;

export const RESET_CHART = `${CHART_SCOPE}/RESET_CHART`;

export const SET_DEFAULT_SLICE = `${CHART_SCOPE}/SET_DEFAULT_SLICE`;

export const SET_SLICE = `${CHART_SCOPE}/SET_SLICE`;

export const RESET_SLICE = `${CHART_SCOPE}/RESET_SLICE`;

export const SET_INTERVAL = `${CHART_SCOPE}/SET_INTERVAL`;

export const INJECT_SHARED_STATE = `${CHART_SCOPE}/INJECT_SHARED_STATE`;

export const SWITCH_ZOOM_BRUSH = `${CHART_SCOPE}/SWITCH_ZOOM_BRUSH`;

export const SET_CHART_TYPE = `${CHART_SCOPE}/SET_CHART_TYPE`;

export const TOGGLE_ENGAGEMENT_TYPE = `${CHART_SCOPE}/TOGGLE_ENGAGEMENT_TYPE`;

export const SET_ENGAGEMENT_TYPE = `${CHART_SCOPE}/SET_ENGAGEMENT_TYPE`;

export const SET_BUCKET = `${CHART_SCOPE}/SET_BUCKET`;

export const FETCHING_INIT_DATA = `${SCOPE}/FETCHING_INIT_DATA`;

export const FETCHING_DATA_WHEN_ZOOM_CHANGE = `${SCOPE}/FETCHING_DATA_WHEN_ZOOM_CHANGE`;

export const FETCHING_DATA_ON_COMPARE_INTERVAL_CHANGE = `${SCOPE}/FETCHING_DATA_ON_COMPARE_INTERVAL_CHANGE`;

export const TRENDS_CHART_COMPARE_TRIGGER = `${SCOPE}/TRENDS_CHART_COMPARE_TRIGGER`;

export const ENABLE_TABLE_COMPARE = `${SCOPE}/ENABLE_TABLE_COMPARE`;
